const React = require('react');
const PropTypes = require('prop-types');
const { Text, Sector } = require('recharts');


const DonutActivePortion = ({ cx, cy, endAngle, payload, startAngle, titles, textWidth }) => (
    <g>
        <Sector
            cx={cx}
            cy={cy}
            fill={payload.fill}
            innerRadius={80}
            outerRadius={103}
            startAngle={startAngle}
            endAngle={endAngle}
        />
        {
            Object.keys(titles).map((title, i) => (
                <Text
                    dy={i * 16}
                    fill="#000000"
                    key={title}
                    textAnchor="middle"
                    x={cx}
                    y={cy}
                    width={textWidth ? textWidth : ''}
                >
                    {
                        titles[title] && typeof titles[title] === 'function'
                        ? titles[title](payload.payload[title])
                        : payload[title]
                    }
                </Text>
            ))
        }
    </g>
);


DonutActivePortion.propTypes = {
    cx: PropTypes.number,
    cy: PropTypes.number,
    endAngle: PropTypes.number,
    fill: PropTypes.string,
    textWidth: PropTypes.string,
    payload: PropTypes.object,
    startAngle: PropTypes.number,
    titles: PropTypes.object,
};


module.exports = DonutActivePortion;
